module.exports = __webpack_public_path__ + "img/mockup_flower@2x.4f775b5b.png";